import React from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import CONSTANT from './../../constant';

import { getEtoorAvailableNotings } from './../../actions/MasterAction';
import { getStorage, onChange, setOptions, validateForm } from './../../utils';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        const recipients = getStorage(CONSTANT.cookie.recipients);
        this.state = {
             
            eTourCode: props.code,
            notingCode: { name: 'notingCode', value: [], options: [], error: '', isRequired: true },
            comment: { name: 'comment', value: '', error: '', isRequired: false },
            to: { name: 'to', value: [], options: recipients, error: '', isRequired: true },
            attachments: { name: 'attachments', value: [], error: '', isRequired: false },
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.login;

        getEtoorAvailableNotings().then((res: any) => {
            setOptions(this, this.state.notingCode.name, res.result);
        });
    }

    render() {
        const { notingCode, comment, to, attachments } = this.state;

        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <form onSubmit={this.onSubmit}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Recipient <small>*</small></label>
                                        <Typeahead
                                            id="ta-recipient"
                                            labelKey={(option: any) => `${option.name} (${option.employeeNumber})`}
                                            name={to.name}
                                            value={to.value}
                                            options={to.options}
                                            onChange={(e: any) => this.typeaheadOnChange(to.name, e)}
                                            placeholder="Send this file to"
                                            isInvalid={to.error.length > 0}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Notings <small>*</small></label>
                                        <select
                                            className={notingCode.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            name={notingCode.name}
                                            value={notingCode.value}
                                            onChange={this.onChange}
                                        >
                                            <option>Select a Noting</option>
                                            {
                                            notingCode.options.map(function (item: any, index: number) {
                                                    return (
                                                        <option key={index} value={item.code}>{item.name}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Message <sup>(optional)</sup></label>
                                        <textarea
                                            rows={5}
                                            className={comment.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder="Enter your message here"
                                            name={comment.name}
                                            value={comment.value}
                                            onChange={this.onChange}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>File(s) <sup>(optional)</sup></label>
                                        <input
                                            name={attachments.name}
                                            onChange={this.onChange}
                                            type="file"
                                            multiple={true}
                                            className="form-control"
                                            style={{ padding: 4 }}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        
                                         {
                                            Array.from(attachments.value).map(function (item: any, index: number) {
                                                return (
                                                    <span key={index} className="badge badge-primary mr-1">{item.name}</span>
                                                )
                                            })
                                        }

                                         
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <button type="button" onClick={this.props.toggleModal} className="btn btn-block cancel-button btn-sm btn-sm">Cancel</button>
                                </div>
                                <div className="col-md-6">
                                    &nbsp;
                                                </div>
                                <div className="col-md-3">
                                    <button type="submit" className="btn btn-block submit-button btn-sm">Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }

    onChange = (e: any) => {
        const name = e.target.name;
        let value = e.target.value;
        if (name === this.state.attachments.name) {
            value = e.target.files;
        }
        onChange(this, name, value);
    }

    typeaheadOnChange = (name: string, e: any) => {
        let value = e;
        if (e.length > 0 && e[0].customOption) {
            value = [{ name: e[0].name }];
        }
        onChange(this, name, value);
    }

    onSubmit = (e: any) => {
        e.preventDefault();
        if (validateForm(this)) {
            const st = this.state;
            const model = {
                eTourCode: st.eTourCode,
                notingCode: st.notingCode.value,
                comment: st.comment.value,
                to: st.to.value.length > 0 ? st.to.value[0].code : null
            };
             
            this.props.onSubmit(model, st.attachments.value);

         }
    }

    // # leaveing for future reference, might be useful
    // canCloseFile = () => {
    //     const { fileOwner, fileOwnerDetail, userDetail } = this.state;
    //     if (fileOwner === userDetail.code) {
    //         return true;
    //     } else if (fileOwnerDetail && fileOwnerDetail.departmentCode === userDetail.departmentCode && userDetail.isHOD) {
    //         return true;
    //     } else {
    //         return false
    //     }
    // }
}

export default ComponentName;